<template>
	<div>
		<v-card-title class="mt-4">
			<h2>Moje opinie eksperckie</h2>
		</v-card-title>
		<expert-evaluation-table/>
	</div>
</template>

<script>
	import ExpertEvaluationTable from "./ExpertEvaluationTable";

	export default {
		name: "ExpertEvaluationList",
		components: {ExpertEvaluationTable},
	};
</script>

<style scoped>

</style>